// ProfileZone — German. The console's language; the record's own content stays French.
// 'not collected', 'Loading…', 'Refresh' and the four tier words live in common.de.ts and are
// not repeated here. The zone has no verb of its own since round 4: the Organisation mast starts
// the research run, and this catalogue only names what the head reads back. The score words and the fetch-date fallback ARE declared below, even though
// other catalogues also carry them: this zone must read German on its own, without depending on
// some unrelated page being in the bundle. The values are byte-identical to the other
// declarations, so the duplicate-key warning in mergeDict never fires.
//
// The raster's own block, cell and value names are NOT in this file: they are declared beside
// their value in `src/shared/raster.v1.ts` and read through `labelFor`.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Profile': 'Profil',
  'one standardised raster of comparable cells': 'ein einheitliches Raster vergleichbarer Zellen',
  '{pct}% of the comparable cells · raster {v}': '{pct}% der vergleichbaren Zellen · Raster {v}',
  'computed nightly · no claim mark': 'nächtlich berechnet · ohne Anspruchszeichen',

  // the last research — the one line where the receipt used to be (R4 §4)
  'last research': 'letzte Recherche',
  'cells filed': 'Zellen eingereicht',
  'still running': 'läuft noch',
  'No research run has been started on this organisation yet.':
    'Für diese Organisation wurde noch kein Rechercheauftrag gestartet.',
  'The run that last worked this raster — its steps, its ledger and every cell it filed':
    'Der Lauf, der dieses Raster zuletzt bearbeitet hat — seine Schritte, sein Journal und jede eingereichte Zelle',

  // the states
  'The profile did not answer': 'Das Profil hat nicht geantwortet',
  'No cell of the raster is filled for this organisation. "Research" on the masthead starts a run; every value it reads comes back as a proposal with its verbatim quote, and nothing is on the record until you hold it.':
    'Für diese Organisation ist keine Rasterzelle gefüllt. «Recherchieren» im Kopf startet einen Lauf; jeder gelesene Wert kommt als Vorschlag mit wörtlichem Zitat zurück, und nichts steht im Bestand, bis Sie ihn übernehmen.',
  'estimated': 'geschätzt',
  'The agent inferred this value; it was not read off a page.':
    'Der Agent hat diesen Wert erschlossen; er wurde nicht von einer Seite abgelesen.',
  'confidence': 'Konfidenz',
  'yes': 'ja',
  'no': 'nein',

  // the evidence
  'evidence': 'Beleg',
  'hide evidence': 'Beleg ausblenden',
  'Show the verbatim evidence for this cell': 'Den wörtlichen Beleg für diese Zelle zeigen',
  'no source ref recorded': 'keine Quellreferenz erfasst',
  'The evidence names a source but keeps no verbatim passage.':
    'Der Beleg nennt eine Quelle, hält aber keine wörtliche Stelle fest.',

  'fit × timing × access': 'Passung × Zeitpunkt × Zugang',
  'fit': 'Passung',
  'timing': 'Zeitpunkt',
  'access': 'Zugang',
  'not scored': 'nicht bewertet',
  'fetch date not recorded': 'Abrufdatum nicht erfasst',

  'cells': 'Zellen',

  // the head's denominator: how many cells a fill may propose
  'of': 'von',
  '{n} of the cells a fill may propose are filled; the percentage beside it is measured over the {d} comparable cells.':
    '{n} der Zellen, die ein Lauf vorschlagen darf, sind gefüllt; der Prozentsatz daneben misst über die {d} vergleichbaren Zellen.',
  'Measured over the comparable cells: this server does not report how many a fill may propose.':
    'Gemessen an den vergleichbaren Zellen: dieser Server meldet nicht, wie viele ein Lauf vorschlagen darf.',

  // the kept document behind a citation
  'Open the kept PDF as the run read it': 'Das aufbewahrte PDF öffnen, wie der Lauf es gelesen hat',
  'not found': 'nicht gefunden',
  'A run searched for this cell and found nothing; later runs leave it alone unless asked to refresh.': 'Ein Lauf hat diese Zelle gesucht und nichts gefunden; spätere Läufe lassen sie in Ruhe, sofern nicht ausdrücklich nachgeforscht wird.',
}, 'ProfileZone');
